import { render, staticRenderFns } from "./Cobrados.vue?vue&type=template&id=6d57f0ac"
import script from "./Cobrados.vue?vue&type=script&lang=js"
export * from "./Cobrados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports